module.exports = __webpack_public_path__ + "img/9.b0c62ced.jpg";